__turbopack_context__.v({
  "button": "styles-module-scss-module__EtJjDG__button",
  "input": "styles-module-scss-module__EtJjDG__input",
  "root": "styles-module-scss-module__EtJjDG__root",
});
